import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Tengo todo planificado hasta diciembre. Mis domingos volvieron a ser míos.',
  name: 'M.L.',
  city: 'Córdoba'
}, {
  quote: 'Ya viene todo secuenciado. No tengo que pensar el orden, solo imprimir y aplicar.',
  name: 'V.R.',
  city: 'Rosario'
}, {
  quote: 'Las rúbricas y fichas son un lujo. Hago los informes en la mitad de tiempo.',
  name: 'S.G.',
  city: 'CABA'
}];
export function Testimonials() {
  return <section className="py-20 bg-brand-900 text-white" data-id="element-156">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-157">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-158">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-800 text-brand-200 font-bold text-sm mb-4" data-id="element-159">
            Lo que dicen nuestras profesionales
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-160">
            Testimonios reales
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-161">
          {testimonials.map((test, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-brand-800/50 rounded-2xl p-8 border border-brand-700" data-id="element-162">
              <div className="flex text-accent mb-6" data-id="element-163">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-164" />)}
              </div>
              <p className="text-lg font-medium text-brand-50 mb-8 italic" data-id="element-165">
                "{test.quote}"
              </p>
              <div data-id="element-166">
                <div className="font-bold text-white" data-id="element-167">{test.name}</div>
                <div className="text-brand-300 text-sm" data-id="element-168">{test.city}</div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}